import React, { useEffect, useState } from "react";
import { PageTitle, Panel, StatCard } from "../components/ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

export default function Intensity() {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  useEffect(() => { CL.getIntensity().then(setD).catch(() => {}); }, []);

  const v = (x, unit) => (x == null ? "—" : `${x.toLocaleString()} ${unit}`);

  return (
    <div data-testid="intensity-page">
      <PageTitle title={t("intensityTitle")} subtitle={t("intensityDesc")} />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <StatCard testId="int-employee" label={t("perEmployee")} value={v(d?.per_employee_t, "tCO₂e")} sub={`${d?.employees ?? 0} çalışan`} />
        <StatCard testId="int-revenue" label={t("perRevenue")} value={v(d?.per_revenue_t_per_meur, "tCO₂e")} accent="#2f8f5b" />
        <StatCard testId="int-area" label={t("perArea")} value={v(d?.per_m2_kg, "kg")} sub={`${(d?.area_m2 ?? 0).toLocaleString()} m²`} accent="#e08a1e" />
      </div>
      <Panel className="mt-6 max-w-2xl">
        <p className="text-sm text-[#6b7268]">{t("fillEntity")}</p>
      </Panel>
    </div>
  );
}
